import { createApp, reactive } from 'petite-vue';

/**
 * A Class to assist registering multiple petite-vue scopes on a single global instance.
 */
export default class PV {

    static store = reactive({
        InitialLoad: false
    });

    /**
     *
     * @param {object} data - global data you would like to access from any scope
     */
    static initializeStore( data ) {
        PV.store = reactive(data);
        PV.registerScope( "globalStore", PV.store );
    }

    static scopes = {
        globalStore: PV.store
    };

    static directives = [];

    /**
     *
     * @param {string} name - name of the scope that will be available in `v-scope`
     * @param {function} scope - a function that returns a petite-vue scope to be used for a specific section.
     */
    static registerScope( name, scope ) {
        PV.scopes[name] = scope;
    }

    /**
     *
     * @param {string} name - name of the petite-vue directive to have `v-` prepended to (eg. 'html' for the v-html directive)
     * @param {function} directive - the petite vue directive function to be registered.
     */
    static registerDirective( name, directive ) {
        PV.directives.push( [name, directive] );
    }

    /**
     * Mount a petite-vue instance
     *
     * @param {string|Element} [mountPoint] - a selector or reference to the element that petite-vue should mount to.
     * @return {{directive(name: string, def?: (Directive<Element> | undefined)): any, mount(el?: (string | Element | null | undefined)): any, unmount(): void}}
     */
    static mount( mountPoint ) {
        const app = createApp( {
            $delimiters: ['{[', ']}'],
            ...PV.scopes
        });
        PV.directives.forEach((e)=>app.directive(...e));
        app.mount(mountPoint);
        return app;
    }
}